import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/finanza';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-294" data-mp="pujaxj4imb7s">
      <div className="mx-auto max-w-6xl" data-id="element-295" data-mp="b5wn0t0tob4y">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl" data-id="element-296" data-mp="b4vcqqrmrsoa">
          Cosa trovi dentro <em className="text-[#1F9D6B]" data-id="element-297" data-mp="269vcyxwajp3">FINANZA PRONTA™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-298" data-mp="23x6s2xmtb32">
          <h3 className="font-serif text-3xl leading-tight text-[#1E2B58] sm:text-4xl lg:col-span-6" data-id="element-299" data-mp="752zi0rakycl">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-[#1E2B58]/75 lg:col-span-6" data-id="element-300" data-mp="3tckom8wnyg5v">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumi" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-301" data-mp="3csuvmv5ykmpq">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-[#1E2B58]/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-[#1F9D6B]/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-302" data-mp="3ltatnp3xn1n7" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-303" data-mp="2y36sdoe7vdzd">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-none sm:text-3xl" data-id="element-304" data-mp="2adcfx7xt7rfn">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-305" data-mp="26br65vgknt9o">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-[#1E2B58]/15 pt-10" data-id="element-306" data-mp="e9xza6xhb80z">
          <AnimatePresence mode="wait" initial={false} data-id="element-307" data-mp="o2dif7kii2ng">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-308" data-mp="o3yb0rn9nbio">
              <div className="lg:col-span-5" data-id="element-309" data-mp="5d76q4i4ybb5">
                <p className="text-sm font-semibold text-[#1F9D6B]" data-id="element-310" data-mp="1brycomm48mc1">
                  {volume.number} · {volume.classes}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-[#1E2B58] sm:text-4xl" data-id="element-311" data-mp="1gpgbhk6f5l6b">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-[#1E2B58]/80" data-id="element-312" data-mp="3180m74slxqft">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-[#1E2B58]/70" data-id="element-313" data-mp="2waimm50hcnkh">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-314" data-mp="2rgxng9n5hnjp">
                <p className="text-sm font-semibold text-[#1E2B58]/60" data-id="element-315" data-mp="2mkpcz9jweiiv">Contiene</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-316" data-mp="2hkkw3if2vls4">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-[#1E2B58]/80" data-id="element-317" data-mp="2djhdwp9k5dnq">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#1F9D6B]" strokeWidth={2.5} aria-hidden="true" data-id="element-318" data-mp="28jmnemtp2q37" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-[#1E2B58]/80" data-id="element-319" data-mp="6tb95al87d9z">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-[#1E2B58]/60" data-id="element-320" data-mp="1uq4myyxy7fq">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-[#1E2B58]/15 pt-12" data-id="element-321" data-mp="2znru80alp40c">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-322" data-mp="2zkxa69vi1l7g">
            <h3 className="font-serif text-3xl leading-tight text-[#1E2B58] sm:text-4xl lg:col-span-6" data-id="element-323" data-mp="2lmz3lqnf6t2i">
              Cosa rende diverso FINANZA PRONTA™?
            </h3>
            <p className="text-lg leading-relaxed text-[#1E2B58]/75 lg:col-span-6" data-id="element-324" data-mp="2bwminxbp0xvu">
              Un anno intero di educazione finanziaria – organizzato e pronto da usare.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-325" data-mp="22y23v79978cw">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-326" data-mp="1sz37an1rj369">
                  <Icon className="h-6 w-6 text-[#1F9D6B]" strokeWidth={1.75} aria-hidden="true" data-id="element-327" data-mp="1t04j4tqlrtp1" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-[#1E2B58]" data-id="element-328" data-mp="1xwl6hlpza412">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-[#1E2B58]/70" data-id="element-329" data-mp="1ecw4tk1zz88u">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}